import styled from 'styled-components';
import { Field } from 'formik';

import { Label } from '@klv/molecules/form-field';
import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';
import type { TColorVariant } from '@klv/shared/styles/types';

export const CheckboxesLabel = styled(Label)``;

export const ErrorContainer = styled.div`
  margin: 1rem 0;
`;

export const FormContainer = styled.div``;

export const FormError = styled(Typography)<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].error};
`;

export const RecaptchaContainer = styled.div`
  margin-bottom: 2rem;
`;

export const StyledFormText = styled(Typography)``;

export const StyledIcon = styled(Icon)<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].successIcon};
  display: inline-block;
  font-size: 3rem;
`;

export const SuccessButtons = styled(Buttons)``;

export const SuccessContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  width: 64rem;
`;

export const SuccessContent = styled.div`
  grid-column: 1 / -1;
  grid-row: 1;
  ${({ theme }) => (`
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 2 / -2;
    }    
    ${theme.screenSize.s1024.mediaQuery}{
      grid-column: 3 / -3;
    }
  `)}

  ${SuccessButtons} {
    justify-content: center;
  }
`;

export const SuccessGrid = styled(Grid)`
  align-content: center;
  align-items: center;
  grid-template-rows: min-content;
  height: 80vh;
  text-align: center;
`;

export const SuccessHeadline = styled(Typography)`
  margin-bottom: 2.5rem;
`;

export const SuccessMessage = styled(Typography)`
  margin-bottom: 2.5rem;
`;

/* Product Interest Checkboxes */
export const CheckboxError = styled.div<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].error};
  user-select: none;
  grid-column: 1 / -1;
`;

export const Checkbox = styled(Field)`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 100%;
  width: 100%;
  left:0;
  z-index: 2;
`;

export const Checkboxes = styled.div<{ $backgroundColor: TColorVariant; $pathPrefix: string; }>`
  display: grid;
  grid-template-columns: 10rem 10rem 10rem;
  column-gap:  ${({ $pathPrefix }) => $pathPrefix === 'fr' ? '3.5rem' : '1rem'};
  row-gap: 1rem;
  margin-bottom: 2.5rem;
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].label};

  ${CheckboxesLabel} {
    grid-column: 1 / -1;
    margin-bottom: 0;
  }
`;
